export const TAB_VALUES = {
  OVERVIEW: 'overview',
  RISK_SCORE: 'risk-score',
  SESSION_RISK_SCORE: 'session-risk-score',
  TRANSACTIONS: 'transactions',
  WATCHLIST: 'watchlist',
};
